import moment from 'moment';
import { DateFilter } from 'src/types/date-filter';

/**
 * getDayDifference
 * returns the day difference between 2 dates
 * returns { number } (including NaN)
 */
export const getDayDifference = ({ startDate, endDate }: DateFilter) => {
  const momentStartDate = moment(startDate);
  const momentEndDate = moment(endDate);

  return momentEndDate.diff(momentStartDate, 'days');
};
